import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import mu5 from "../assets/mu5.png";
import python from "../assets/python.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";

// BBM-FILES
import logoMark from "../assets/bbm-files/logoMark.png";
import adidas from "../assets/bbm-files/adidas.png";
import asus from "../assets/bbm-files/asus.png";
import bolt from "../assets/bbm-files/bolt.png";
import nb from "../assets/bbm-files/nb.png";
import skype from "../assets/bbm-files/skype.png";
import spotify from "../assets/bbm-files/spotify.png";
import nneka from "../assets/bbm-files/nneka.jpg";
import abdullateef from "../assets/bbm-files/abdullateef.jpg";
import abdulsamad from "../assets/bbm-files/abdulsamad.jpg";
import fawziyat from "../assets/bbm-files/fawziyat.jpg";
// outside
import react from "../assets/bbm-files/logoMark.png";
import node from "../assets/bbm-files/flat-sheild.png";
import javascript from "../assets/bbm-files/lock.png";
import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";
import testi2 from "../assets/testi2.jpeg";
import testi1 from "../assets/testi1.avif";
import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";

const images = {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  profile,
  // BBM-FILES
  logoMark,
  adidas,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  nneka,
  fawziyat,
  abdullateef,
  abdulsamad,
  // outside
  circle,
  about01,
  about02,
  about03,
  about04,
  testi1,
  testi2,
};

export default images;
